// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1Dmyj{fill:#5e6e97;height:16px;height:1.6rem;stroke:#5e6e97;width:16px;width:1.6rem}html[dir=rtl] ._1Dmyj{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}", ""]);
// Exports
exports.locals = {
	"arrow": "_1Dmyj"
};
module.exports = exports;
